import { SimpleSelectFormField, Typography } from "@/components/ui";
import { MEDICAL_TREATMENT_MISSED_REASONS } from "@/lib/data/static/matterStatics";
import type { MedicalTreatmentAppointment } from "@/lib/types";
import { useFormContext, useWatch } from "react-hook-form";

type OutcomeFields = Pick<
  MedicalTreatmentAppointment,
  "outcome" | "missedReason"
>;

export function TreatmentAppointmentOutcomeFields({
  legacyReason,
}: {
  legacyReason?: string | null;
}) {
  const form = useFormContext<OutcomeFields>();
  const outcome = useWatch({ control: form.control, name: "outcome" });

  return (
    <>
      <SimpleSelectFormField
        register={form.register("outcome")}
        label="Outcome"
        placeholder="Select outcome"
        items={["missed", "attended", "scheduled"]}
        clearable
        onChange={(value) => {
          if (value !== "missed") {
            form.setValue("missedReason", "", { shouldDirty: true });
          }
        }}
      />
      {outcome === "missed" && (
        <SimpleSelectFormField
          register={form.register("missedReason")}
          label="Missed reason"
          placeholder="Select reason"
          items={MEDICAL_TREATMENT_MISSED_REASONS}
          formatItemLabel={(value) =>
            value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
          }
          clearable
        />
      )}
      {legacyReason && (
        <Typography size="sm" className="text-muted-foreground">
          Previous no-show reason: {legacyReason}
        </Typography>
      )}
    </>
  );
}
